import { useCallback } from "react";
import {
  P2Alert,
  P2Checkbox,
  P2TextDescription,
  P2TextLabel,
} from "react-bootstrap-common-script";
import { HDBLinks } from "../../../utils/shared/links";



interface DeclarationProps {
   setCheckboxValue: () => void;
   checkboxValue?: boolean;
   forceError?: boolean;
   disabled?:boolean;
}

function Declaration({
    setCheckboxValue,
    checkboxValue,
    forceError,
    disabled=false
}: DeclarationProps) {

  const handleCheckbox = useCallback(()=>{
    setCheckboxValue();
  },[setCheckboxValue])
  return (
    <>
      {" "}
      <div className="polymer-declaration-container">
        <div className="polymer-declaration-title">
          <P2TextDescription
            color="#000"
            title="Declaration and Authorisation"
          />
        </div>
        <div className="polymer-declaration-checkbox" style={{ marginBottom: 32 }}>
          <P2Checkbox
            variant={!disabled ? "default" : "disabled"}
            isActive={checkboxValue}
            onClick={handleCheckbox}
            description={
              <P2TextLabel label={<span className="m-0">We, the current and proposed flat owner(s) declare that:</span>}/>
            }
          />        
          {forceError && !checkboxValue &&         
            <div style={{ marginTop: 12}}>
              <P2Alert variant={"danger"} text={"This is a required field."}></P2Alert>
            </div>
          }
        </div>
        <ol style={{ marginBottom: 0 }}>
          <li className="polymer-declaration-item" >
            The particulars given in this Application Form are true and correct,
            and we have not withheld any information required in this
            Application Form.
          </li>
          <li className="polymer-declaration-item" >
            Other than the persons (if any) listed in the Declaration of
            Ownership of Private Property, neither we, our spouse(s) nor any
            persons listed in this application [including all authorised
            occupiers listed in this Application Form],
          </li>
          <ol type="a" style={{marginBottom: 26}}>
            <li>
              own or have an estate or interest in any other flat, house,
              building or land; or
            </li>
            <li>
              have at any time within 30 months immediately prior to the date of
              application sold any other flat [e.g. HDB/JTC/HUDC/Executive
              Condominium etc], house, buildings or land or divested ourselves
              of any interest in such a property; or
            </li>
            <li>
              have not made any arrangements or promises or entered into any
              agreement with other persons in the sale/parting of possession of
              the said flat.
            </li>
          </ol>
          <li className="polymer-declaration-item" >
            We are not undischarged bankrupt(s) and/or have not had bankruptcy proceedings filed against us at any point of time. [Undischarged bankrupts and/or parties who have had bankruptcy proceedings filed against them at any point of time must obtain prior approval from the Official Assignee for the change in flat ownership]
          </li>
          <li className="polymer-declaration-item" >
            There are no outstanding judgements against us or court cases
            pending against us.
          </li>
          <li className="polymer-declaration-item" >
            We do not suffer, nor are we aware that we are suffering from any
            mental disorder or impairment. We have also not been diagnosed to
            suffer from these mental conditions, which will affect our
            understanding of the nature and effect of this Change in Flat
            Ownership. Further, there is no fraud or undue pressure inducing or
            forcing us directly or indirectly to give our consent and authority
            to the Change in Flat Ownership.
          </li>
          <li className="polymer-declaration-item" >
            We have read and understood the{" "}
            <span onClick={()=>{
              setTimeout(() => window.open(HDBLinks.terms_and_conditions, "_blank"))
            }} style={{ color: "#085054", cursor: "pointer" }}>
              Terms & Conditions
            </span>{" "}
            for Change in Flat Ownership attached and accept that the HDB shall
            have the right to unilaterally introduce new terms and conditions,
            at any time, even if such new terms and conditions may adversely
            affect our eligibility for the change in flat ownership.
          </li>
          <li className="polymer-declaration-item" >
            The HDB shall have the right to reject any application with
            incomplete information or applications deemed ineligible for
            whatever reason.
          </li>
          <li className="polymer-declaration-item" >
            We understand and accept that:
            <ol type="a">
              <li>
                The HDB has the right to reject/cancel this application
                notwithstanding that approval may have been granted, at any time
                whensoever if we become ineligible to own the HDB flat or if we,
                our spouse or any of the persons listed have between the date of
                this application and the date of completion of the change in
                flat ownership acquired/sold any flat, house, building or land
                or acquired/divested any interest therein as owner thereof or
                through a nominee without HDB’s prior approval /exemption.
              </li>
              <li>
                If any information given in this Application Form is false or
                incorrect or if we have withheld any information required in the
                form, our application shall be rejected and HDB shall be
                entitled to revoke the approval which it may have granted for
                the change in ownership of the HDB flat. In such event, all
                monies paid will be forfeited by the HDB.
              </li>
            </ol>
          </li>
          <li className="polymer-declaration-item" >
            We authorise the HDB to have access to and request any information regarding our account(s) with the CPF Board and to release our particulars to CPF Board for the purpose of or relating to or in connection with this application. We understand and agree that HDB shall rely on its own records and/or the records of other relevant authorities to obtain or verify any information relating to or in connection with the application.  In this regard, we authorise HDB to write to and request for information from all the applicants and relevant authorities for any information in connection with the application.
          </li>
          <li className="polymer-declaration-item" >
            We authorise the HDB to have access to and request any information
            regarding our account(s) with the CPF Board and to release our
            particulars to CPF Board in the event that we are taking a loan from
            HDB and there are any instalment arrears for payment of the HDB
            mortgage loan owing on my/our flat after the completion of the
            change in flat ownership. If you do not wish to authorise HDB to do so, you must notify HDB in writing. In this case, you will have to obtain your CPF account information from CPF Board on your own and give it to HDB when requested, if you want to use your CPF monies in the purchase and/or payment of any mortgage instalment arrears subsequently.
          </li>
          <li className="polymer-declaration-item" >
            We understand that the relevant provisions in the Bankruptcy Act / Insolvency Restructuring & Dissolution Act and any other relevant legislation relating to gift transactions may apply if there is any future transaction on this flat within 5 years and/or other applicable timeframe from the date this transaction is finalised.
          </li>
        </ol>
      </div>
    </>
  );
}

export default Declaration;
